export default __webpack_public_path__ + "assets/537b3df125855cf0664e8a27e10dd0ce.svg";